// extracted by mini-css-extract-plugin
export default {"theHeader":"Nepz6V","dummyRelativeNew":"Lq6vOc","dummyRelativeNewV2":"nZ0ycR","headerContainer":"xd_vwt","backButton":"cqa53E","headerTitle":"qsuWGm"};